import React from 'react';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import {
    ContainerFieldsList,
    CustomBreadcrumbs,
    CustomSelectInput,
} from 'candy-commons-components';
import {
    BooleanInput,
    Edit,
    required,
    SaveButton,
    SimpleForm,
    TextInput,
    Toolbar,
    useTranslate,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

const WIDGET_CHOICES = [{ id: 'wallet', name: 'Wallet' }];

const TYPE_CHOICES = [
    { id: 'warranty', name: 'Warranty' },
    { id: 'expenses', name: 'Expenses' },
];

const useToolbarStyles = makeStyles({
    toolbar: {
        display: 'flex',
        justifyContent: 'flex-start',
    },
});

const WalletCategoryToolbar = (props) => (
    <Toolbar {...props} classes={useToolbarStyles()}>
        <SaveButton />
    </Toolbar>
);

const WalletCategoryEdit = ({ permissions, ...props }) => {
    const translation = useTranslate();
    const breadcrumbsData = [
        {
            text: translation('resources.wallet-category.name'),
            url: 'wallet-category',
            icon: <AccountBalanceWalletIcon />,
        },
        {
            text: translation('resources.wallet-category.edit.name'),
            url: '',
        },
    ];
    return (
        <>
            <CustomBreadcrumbs data={breadcrumbsData} />
            <Edit {...props}>
                <SimpleForm toolbar={<WalletCategoryToolbar />}>
                    <ContainerFieldsList>
                        {/* Read-only fields — not editable after creation */}
                        <CustomSelectInput
                            source="widget"
                            choices={WIDGET_CHOICES}
                            validate={[required()]}
                            label="Widget"
                            disabled
                        />
                        <CustomSelectInput
                            source="type"
                            choices={TYPE_CHOICES}
                            validate={[required()]}
                            label="Type"
                            disabled
                        />
                        <TextInput
                            source="code"
                            label="Code"
                            validate={[required()]}
                            disabled
                        />
                        <TextInput
                            source="name"
                            label="Name"
                            validate={[required()]}
                            disabled
                        />
                        <TextInput
                            source="color"
                            label="Color (hex)"
                            validate={[required()]}
                            disabled
                        />
                        {/* Editable fields */}
                        <TextInput
                            source="icon"
                            label="Icon"
                            helperText="Icon identifier or URL used by the mobile app."
                        />
                        <BooleanInput source="active" label="Active" />
                    </ContainerFieldsList>
                </SimpleForm>
            </Edit>
        </>
    );
};

export default WalletCategoryEdit;
